<template>
  <MobileLayout :showTopBar="false">
    <div class="mobile-account-page">
      <div class="acct-wrap">
        <div class="acct-content" v-if="!isEditing">

          <div v-if="!isLogin" class="acct-hero" style="padding-top: 25%;">
            <div class="acct-title">Login to unlock exclusive access</div>
          </div>
          <div v-if="!isLogin" class="acct-actions">
            <div class="acct-info"></div>
            <button class="acct-action" type="button" @click="login" style="text-decoration: none;">
              Login
            </button>
            <button class="acct-action" style="margin-left: 17rem;text-decoration: none;" type="button" @click="register">
              Register
            </button>
          </div>
          <div v-else>
            <div class="acct-hero">
              <div class="acct-title">Hey, Big {{ userInfo.UserName }}</div>
              <div class="acct-subtitle">{{ userType === 'private' ? 'Private customer' : 'Trade account' }}
              </div>
            </div>

            <div class="acct-info">
              <div v-if="userType === 'private'" class="acct-info-col">
                <div class="acct-name">{{ userInfo.FirstName }} {{ userInfo.LastName }}</div>
              </div>
              <div v-else class="acct-info-col">
                <div class="acct-name">{{ userInfo.Position }}</div>
              </div>
              <div class="acct-info-col acct-info-right">
                <div v-if="userType === 'private'" class="acct-email">{{ userInfo.Email }}</div>
                <div v-else class="acct-email">{{ userInfo.CompanyName }}</div>
              </div>
            </div>
            <div style="text-align:center;">
              <button class="acct-edit" type="button" @click="handleEdit">Edit Details</button>
            </div>
            <div class="acct-actions" style="text-align: center;">
              <button class="acct-action" type="button" @click="switchUserType">
                {{ userType === 'private' ? "I'm a trade *" : "Explore Exclusive Content" }}
              </button>
              <button class="acct-action" style="margin-left: 17rem;" :style='userType === "private" ? "" : "margin-top: 86rem"' type="button" @click="logout">Log
                Out</button>
            </div>
          </div>
        </div>

        <!-- 编辑表单 -->
        <div class="acct-content" v-else>
          <div class="acct-hero">
            <div class="acct-title">Edit Details</div>
          </div>

          <div class="edit-form">
            <div class="edit-field" v-for="field in editFieldList" :key="field.key">
              <label class="edit-label">{{ field.label }}</label>
              <input v-model="editForm[field.key]" class="edit-input"
                :placeholder="field.placeholder || `Enter your ${field.label}`"
                :type="field.type || 'text'" />
            </div>
            <div class="edit-actions">
              <button class="edit-cancel" type="button" @click="cancelEdit">Cancel</button>
              <button class="edit-save" type="button" @click="saveEdit">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MobileLayout>
</template>

<script>
  import MobileLayout from '@/components/mobile/MobileLayout.vue'
  import {
    getUser,
    setUser,
    clearToken,
    clearUser
  } from '@/config/auth'
  import {
    getUserInfo,
    updateUserInfo
  } from '@/api/user'
  import {
    showMessage
  } from '@/config/message'

  export default {
    name: 'MobileAccount',
    components: {
      MobileLayout
    },
    data() {
      return {
        userId: null,
        userType: 'private',
        userInfo: {
          UserID: null,
          UserName: '',
          Email: '',
          FirstName: '',
          LastName: '',
          CompanyName: '',
          Position: '',
          Phone: '',
          UserType: 'private',
          Country: ''
        },
        isEditing: false,
        isLogin: false,
        editForm: {
          FirstName: '',
          LastName: '',
          Email: '',
          Phone: '',
          CompanyName: '',
          Position: '',
          Country: ''
        }
      }
    },
    computed: {
      editFieldList() {
        if (this.userType === 'private') {
          return [
            { key: 'FirstName', label: 'First Name' },
            { key: 'LastName', label: 'Last Name' },
            { key: 'Email', label: 'Email', type: 'email' },
            { key: 'Phone', label: 'Phone' },
            { key: 'Country', label: 'Country' }
          ]
        }
        return [
          { key: 'CompanyName', label: 'Company Name' },
          { key: 'Position', label: 'Position' },
          { key: 'FirstName', label: 'First Name' },
          { key: 'LastName', label: 'Last Name' },
          { key: 'Email', label: 'Email', type: 'email' },
          { key: 'Phone', label: 'Phone' },
          { key: 'Country', label: 'Country' }
        ]
      }
    },
    mounted() {
      // 禁止 body 滚动，仅此页面生效
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
      document.addEventListener('touchmove', this.preventTouchMove, { passive: false })
      this.loadUserInfo()
    },
    beforeDestroy() {
      // 恢复 body 滚动
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
      document.removeEventListener('touchmove', this.preventTouchMove)
    },
    methods: {
      preventTouchMove(e) {
        const scrollable = e.target.closest('.mobile-account-page')
        if (!scrollable) {
          e.preventDefault()
        }
      },
      async loadUserInfo() {
        const user = getUser()
        if (!user) {
          // 未登录时，也需要显示登录界面，触发 ready
          this.$nextTick(() => {
            window.dispatchEvent(new Event('page-ready'))
          })
          return
        }
        const userId = user.UserID || user.UserId || user.id
        if (!userId) {
          showMessage('User ID not found', 'error')
          this.$nextTick(() => {
            window.dispatchEvent(new Event('page-ready'))
          })
          return
        }
        this.isLogin = true
        this.userId = userId
        this.userType = (user.UserType || '').toLowerCase() === 'trader' ? 'trader' : 'private'
      
        try {
          const res = await getUserInfo(Number(userId))
          setUser(res)
          this.userInfo = {
            UserID: res.UserID,
            UserName: `${res.FirstName || ''}`.trim() || res.Email,
            Email: res.Email,
            FirstName: res.FirstName || '',
            LastName: res.LastName || '',
            CompanyName: res.CompanyName || '',
            Position: res.Position || '',
            Phone: res.Phone || '',
            UserType: res.UserType,
            Country: res.Country || ''
          }
        } catch (error) {
          console.error('Failed to load user info:', error)
          this.userInfo = {
            UserID: userId,
            UserName: `${user.FirstName || ''} ${user.LastName || ''}`.trim() || user.Email,
            Email: user.Email,
            FirstName: user.FirstName || '',
            LastName: user.LastName || '',
            CompanyName: user.CompanyName || '',
            Position: user.Position || '',
            Phone: user.Phone || '',
            UserType: user.UserType,
            Country: user.Country || ''
          }
        } finally {
          // ★ 数据已赋值，DOM 更新后触发 page-ready
          this.$nextTick(() => {
            window.dispatchEvent(new Event('page-ready'))
          })
        }
      },
      handleEdit() {
        this.isEditing = true
        this.editForm.FirstName = this.userInfo.FirstName || ''
        this.editForm.LastName = this.userInfo.LastName || ''
        this.editForm.Email = this.userInfo.Email || ''
        this.editForm.Phone = this.userInfo.Phone || ''
        this.editForm.CompanyName = this.userInfo.CompanyName || ''
        this.editForm.Position = this.userInfo.Position || ''
        this.editForm.Country = this.userInfo.Country || ''
      },
      cancelEdit() {
        this.isEditing = false
      },
      async saveEdit() {
        if (!this.userId) {
          showMessage('User ID missing', 'error')
          return
        }
        const payload = {
          UserID: Number(this.userId),
          FirstName: this.editForm.FirstName || '',
          LastName: this.editForm.LastName || '',
          Phone: this.editForm.Phone || '',
          CompanyName: this.editForm.CompanyName || '',
          Position: this.editForm.Position || '',
          Country: this.editForm.Country || ''
        }
        try {
          const res = await updateUserInfo(payload)
          console.log('Update response:', res)

          let isSuccess = false
          if (res === true) {
            isSuccess = true
          } else if (res && typeof res === 'object') {
            const data = res.data || res
            if (data && data.retCode === 1) {
              isSuccess = true
            }
          }

          if (isSuccess) {
            this.userInfo.FirstName = this.editForm.FirstName || ''
            this.userInfo.LastName = this.editForm.LastName || ''
            this.userInfo.Email = this.editForm.Email || ''
            this.userInfo.Phone = this.editForm.Phone || ''
            this.userInfo.CompanyName = this.editForm.CompanyName || ''
            this.userInfo.Position = this.editForm.Position || ''
            this.userInfo.Country = this.editForm.Country || ''
            setUser(this.userInfo)
            showMessage('Saved successfully', 'success')
            this.isEditing = false
          } else {
            const msg = (res && typeof res === 'object' && res.retMsg) ? res.retMsg : 'Update failed'
            showMessage(msg, 'error')
          }
        } catch (error) {
          console.error('Update error:', error)
          showMessage('Update failed: ' + (error.message || ''), 'error')
        }
      },
      logout() {
        clearToken()
        clearUser()
        this.$router.push('/m/user-info')
      },
      register() {
        clearToken()
        clearUser()
        this.$router.push('/m/user-info?mode=register')
      },
      login() {
        clearToken()
        clearUser()
        this.$router.push('/m/user-info')
      },
      switchUserType() {
        const targetType = this.userType === 'private' ? 'trader' : 'private'
        this.$router.push(`/m/user-info?type=${targetType}`)
      }
    }
  }
</script>

<!-- 注意：此处删除了原本不带 scoped 的全局样式 -->
<style scoped>
  /* 滚动容器：全屏固定，不可滚动 */
  .mobile-account-page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    overflow-y: hidden;   /* 禁止内部滚动，如需内部滚动可改为 auto，但 body 已被锁定 */
    background: #fff;
  }

  .acct-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Apercu-Medium', sans-serif !important;
    padding: 90rem 60rem 70rem;
    position: relative;
  }

  .acct-content {
    width: 100%;
    max-width: 320rem;
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 44rem;
    z-index: 1;
  }

  .acct-hero {
    display: flex;
    flex-direction: column;
  }

  .acct-title {
    font-size: 24rem;
    font-weight: 500;
    color: #000;
    font-family: 'Apercu-Medium', sans-serif;
  }

  .acct-subtitle {
    font-size: 20rem;
    color: #999;
    margin-top: 14rem;
  }

  .acct-info {
    width: 100%;
    margin-top: 115rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 16rem;
    color: #000;
  }

  .acct-info-col {
    display: flex;
    flex-direction: column;
  }

  .acct-info-right {
    align-items: flex-end;
  }

  .acct-name {
    font-weight: 500;
    color: #555;
  }

  .acct-email {
    color: #555;
  }

  .acct-edit {
    background: none;
    border: none;
    padding: 0;
    font-size: 16rem;
    color: #000;
    font-weight: 500;
    margin-top: 24rem;
    font-family: 'Apercu-Medium', sans-serif !important;
    cursor: pointer;
  }

  .acct-actions {
    align-items: center;
    gap: 12rem;
    color: #000;
    margin-top: 90rem;
  }

  .acct-action {
    background: none;
    border: none;
    padding: 0;
    font-size: 16rem;
    color: #000;
    font-family: 'Apercu-Medium', sans-serif !important;
    cursor: pointer;
  }

  /* 底部图片可保留，但此处未用，若使用可取消注释 */
  /*
  .acct-illustration {
    position: fixed;
    bottom: 55rem;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    opacity: 0.35;
    z-index: 0;
    display: flex;
    justify-content: center;
    pointer-events: none;
  }
  .acct-illustration img {
    width: 90%;
    height: auto;
    max-height: 518rem;
    display: block;
  }
  */

  .edit-form {
    width: 100%;
    max-width: 300rem;
    display: flex;
    flex-direction: column;
    gap: 20rem;
    margin-top: 20rem;
  }

  .edit-field {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  .edit-label {
    font-size: 14rem;
    color: rgba(0, 0, 0, 0.5);
    font-weight: 500;
    font-family: 'Apercu-Medium', sans-serif;
  }

  .edit-input {
    border: none;
    border-bottom: 1rem solid #000;
    padding: 8rem 2rem;
    font-size: 16rem;
    outline: none;
    color: #000;
    background: transparent !important;
    font-family: 'Apercu-Medium', sans-serif;
  }

  .edit-actions {
    display: flex;
    justify-content: center;
    gap: 20rem;
    margin-top: 20rem;
  }

  .edit-cancel,
  .edit-save {
    background: #fff;
    font-family: 'Apercu-Medium', sans-serif !important;
    cursor: pointer;
    padding: 0;
    border: 1rem solid #000;
    color: #000;
    font-size: 12rem;
    font-weight: 500;
    height: 32rem;
    line-height: 32rem;
    width: 90rem;
    border-radius: 16rem;
  }

  .edit-save {
    font-weight: 600;
  }
</style>